var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 10.0003C60 4.85795 54.9425 1.24086 50.0761 2.90283L30.0761 9.7332C27.0402 10.77 25 13.6227 25 16.8307V32.5003H10C5.85786 32.5003 2.5 35.8582 2.5 40.0003V70.0003C2.5 74.1425 5.85786 77.5003 10 77.5003H44.6859C42.5642 76.1381 40.6735 74.4476 39.0854 72.5003H30V16.8307C30 15.7613 30.6801 14.8105 31.692 14.4648L51.692 7.6345C53.3141 7.08051 55 8.28621 55 10.0003V33.8803C55.8216 33.7943 56.6556 33.7503 57.5 33.7503C58.3444 33.7503 59.1784 33.7943 60 33.8803V10.0003ZM7.5 70.0003C7.5 71.3811 8.61929 72.5003 10 72.5003V66.2503C10 62.7986 12.7983 60.0003 16.25 60.0003C19.7017 60.0003 22.5 62.7986 22.5 66.2503V72.5003H25V37.5003H10C8.61929 37.5003 7.5 38.6196 7.5 40.0003V70.0003ZM17.5 72.5003V66.2503C17.5 65.56 16.9404 65.0003 16.25 65.0003C15.5596 65.0003 15 65.56 15 66.2503V72.5003H17.5Z",
    fill: "#515557"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4432 40C43.3665 38.2344 45.5818 36.7818 48.0081 35.7226C47.5565 35.2759 46.9355 35 46.25 35H38.75C37.3693 35 36.25 36.1193 36.25 37.5C36.25 38.8807 37.3693 40 38.75 40H41.4432Z",
    fill: "#515557"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 25C47.6307 25 48.75 26.1193 48.75 27.5C48.75 28.8807 47.6307 30 46.25 30H38.75C37.3693 30 36.25 28.8807 36.25 27.5C36.25 26.1193 37.3693 25 38.75 25H46.25Z",
    fill: "#515557"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5 37.5C68.5457 37.5 77.5 46.4542 77.5 57.5C77.5 68.5457 68.5457 77.5 57.5 77.5C46.4542 77.5 37.5 68.5457 37.5 57.5C37.5 46.4542 46.4542 37.5 57.5 37.5ZM65.4419 44.7726C63.1388 43.3324 60.4166 42.5 57.5 42.5C49.2157 42.5 42.5 49.2157 42.5 57.5C42.5 60.4166 43.3324 63.1388 44.7726 65.4419L65.4419 44.7726ZM69.188 48.0975L48.0975 69.188C50.6698 71.2599 53.94 72.5 57.5 72.5C65.7843 72.5 72.5 65.7843 72.5 57.5C72.5 53.94 71.2599 50.6698 69.188 48.0975Z",
    fill: "#515557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.f86c25517ffab8eec026702de6aa5c9c.svg";
export { ForwardRef as ReactComponent };